import { useRef } from 'react';
import { useReducedMotion } from './hooks';

// 2.5D parallax container. Children with `data-depth="0.6"` drift against the pointer (desktop) — the further the
// number from 0, the more they move. Sets --mx/--my in -1..1 on the container; CSS does the transform.
export default function Depth({ as: Tag = 'div', className = '', strength = 1, children, ...rest }) {
  const ref = useRef(null);
  const reduced = useReducedMotion();

  const onMove = (e) => {
    if (reduced) return;
    const el = ref.current;
    if (!el) return;
    const r = el.getBoundingClientRect();
    const mx = ((e.clientX - r.left) / r.width - 0.5) * 2 * strength;
    const my = ((e.clientY - r.top) / r.height - 0.5) * 2 * strength;
    el.style.setProperty('--mx', mx.toFixed(3));
    el.style.setProperty('--my', my.toFixed(3));
  };
  const onLeave = () => {
    const el = ref.current;
    if (!el) return;
    el.style.setProperty('--mx', '0');
    el.style.setProperty('--my', '0');
  };

  return (
    <Tag ref={ref} className={`depth ${className}`} onMouseMove={onMove} onMouseLeave={onLeave} {...rest}>
      {children}
    </Tag>
  );
}
